import _slicedToArray from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _asyncToGenerator from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import { Constants } from "./Constants";
import { isSsr } from "../../Utils/Utils";
function manageListener(element, event, handler, add, options) {
  if (add) {
    var addOptions = {
      passive: true
    };
    if (typeof options === "boolean") {
      addOptions.capture = options;
    } else if (options !== undefined) {
      addOptions = options;
    }
    element.addEventListener(event, handler, addOptions);
  } else {
    var removeOptions = options;
    element.removeEventListener(event, handler, removeOptions);
  }
}
export var EventListeners = /*#__PURE__*/function () {
  function EventListeners(container) {
    var _this = this;
    _classCallCheck(this, EventListeners);
    this.container = container;
    this.canPush = true;
    this.mouseMoveHandler = function (e) {
      return _this.mouseTouchMove(e);
    };
    this.touchStartHandler = function (e) {
      return _this.mouseTouchMove(e);
    };
    this.touchMoveHandler = function (e) {
      return _this.mouseTouchMove(e);
    };
    this.touchEndHandler = function () {
      return _this.mouseTouchFinish();
    };
    this.mouseLeaveHandler = function () {
      return _this.mouseTouchFinish();
    };
    this.touchCancelHandler = function () {
      return _this.mouseTouchFinish();
    };
    this.touchEndClickHandler = function (e) {
      return _this.mouseTouchClick(e);
    };
    this.mouseUpHandler = function (e) {
      return _this.mouseTouchClick(e);
    };
    this.mouseDownHandler = function () {
      return _this.mouseDown();
    };
    this.visibilityChangeHandler = function () {
      return _this.handleVisibilityChange();
    };
    this.themeChangeHandler = function (e) {
      return _this.handleThemeChange(e);
    };
    this.oldThemeChangeHandler = function (e) {
      return _this.handleThemeChange(e);
    };
    this.resizeHandler = function () {
      return _this.handleWindowResize();
    };
  }
  _createClass(EventListeners, [{
    key: "addListeners",
    value: function addListeners() {
      this.manageListeners(true);
    }
  }, {
    key: "removeListeners",
    value: function removeListeners() {
      this.manageListeners(false);
    }
  }, {
    key: "manageListeners",
    value: function manageListeners(add) {
      var _this2 = this;
      var _a;
      var container = this.container,
        options = container.actualOptions,
        detectType = options.interactivity.detectsOn;
      var mouseLeaveEvent = Constants.mouseLeaveEvent;
      if (detectType === "window") {
        container.interactivity.element = window;
        mouseLeaveEvent = Constants.mouseOutEvent;
      } else if (detectType === "parent" && container.canvas.element) {
        var canvasEl = container.canvas.element;
        container.interactivity.element = (_a = canvasEl.parentElement) !== null && _a !== void 0 ? _a : canvasEl.parentNode;
      } else {
        container.interactivity.element = container.canvas.element;
      }
      var mediaMatch = !isSsr() && typeof matchMedia !== "undefined" && matchMedia("(prefers-color-scheme: dark)");
      if (mediaMatch) {
        if (mediaMatch.addEventListener !== undefined) {
          manageListener(mediaMatch, "change", this.themeChangeHandler, add);
        } else if (mediaMatch.addListener !== undefined) {
          if (add) {
            mediaMatch.addListener(this.oldThemeChangeHandler);
          } else {
            mediaMatch.removeListener(this.oldThemeChangeHandler);
          }
        }
      }
      var interactivityEl = container.interactivity.element;
      if (!interactivityEl) {
        return;
      }
      var html = interactivityEl;
      if (options.interactivity.events.onHover.enable || options.interactivity.events.onClick.enable) {
        manageListener(interactivityEl, Constants.mouseMoveEvent, this.mouseMoveHandler, add);
        manageListener(interactivityEl, Constants.touchStartEvent, this.touchStartHandler, add);
        manageListener(interactivityEl, Constants.touchMoveEvent, this.touchMoveHandler, add);
        if (!options.interactivity.events.onClick.enable) {
          manageListener(interactivityEl, Constants.touchEndEvent, this.touchEndHandler, add);
        } else {
          manageListener(interactivityEl, Constants.touchEndEvent, this.touchEndClickHandler, add);
          manageListener(interactivityEl, Constants.mouseUpEvent, this.mouseUpHandler, add);
          manageListener(interactivityEl, Constants.mouseDownEvent, this.mouseDownHandler, add);
        }
        manageListener(interactivityEl, mouseLeaveEvent, this.mouseLeaveHandler, add);
        manageListener(interactivityEl, Constants.touchCancelEvent, this.touchCancelHandler, add);
      }
      if (container.canvas.element) {
        container.canvas.element.style.pointerEvents = html === container.canvas.element ? "initial" : "none";
      }
      if (options.interactivity.events.resize) {
        if (typeof ResizeObserver !== "undefined") {
          if (this.resizeObserver && !add) {
            if (container.canvas.element) {
              this.resizeObserver.unobserve(container.canvas.element);
            }
            this.resizeObserver.disconnect();
            delete this.resizeObserver;
          } else if (!this.resizeObserver && add && container.canvas.element) {
            this.resizeObserver = new ResizeObserver(function (entries) {
              var entry = entries.find(function (e) {
                return e.target === container.canvas.element;
              });
              if (!entry) {
                return;
              }
              _this2.handleWindowResize();
            });
            this.resizeObserver.observe(container.canvas.element);
          }
        } else {
          manageListener(window, Constants.resizeEvent, this.resizeHandler, add);
        }
      }
      if (document) {
        manageListener(document, Constants.visibilityChangeEvent, this.visibilityChangeHandler, add, false);
      }
    }
  }, {
    key: "handleWindowResize",
    value: function handleWindowResize() {
      var _this3 = this;
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
        delete this.resizeTimeout;
      }
      this.resizeTimeout = setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _a;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (_a = _this3.container.canvas) === null || _a === void 0 ? void 0 : _a.windowResize();
            case 2:
              return _context.abrupt("return", _context.sent);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })), 500);
    }
  }, {
    key: "handleVisibilityChange",
    value: function handleVisibilityChange() {
      var container = this.container,
        options = container.actualOptions;
      this.mouseTouchFinish();
      if (!options.pauseOnBlur) {
        return;
      }
      if (document === null || document === void 0 ? void 0 : document.hidden) {
        container.pageHidden = true;
        container.pause();
      } else {
        container.pageHidden = false;
        if (container.getAnimationStatus()) {
          container.play(true);
        } else {
          container.draw(true);
        }
      }
    }
  }, {
    key: "mouseDown",
    value: function mouseDown() {
      var interactivity = this.container.interactivity;
      if (interactivity) {
        var mouse = interactivity.mouse;
        mouse.clicking = true;
        mouse.downPosition = mouse.position;
      }
    }
  }, {
    key: "mouseTouchMove",
    value: function mouseTouchMove(e) {
      var _a, _b, _c, _d, _e, _f, _g;
      var container = this.container,
        options = container.actualOptions;
      if (!((_a = container.interactivity) === null || _a === void 0 ? void 0 : _a.element)) {
        return;
      }
      container.interactivity.mouse.inside = true;
      var pos;
      var canvas = container.canvas.element;
      if (e.type.startsWith("mouse")) {
        this.canPush = true;
        var mouseEvent = e;
        if (container.interactivity.element === window) {
          if (canvas) {
            var clientRect = canvas.getBoundingClientRect();
            pos = {
              x: mouseEvent.clientX - clientRect.left,
              y: mouseEvent.clientY - clientRect.top
            };
          }
        } else if (options.interactivity.detectsOn === "parent") {
          var source = mouseEvent.target;
          var target = mouseEvent.currentTarget;
          var canvasEl = container.canvas.element;
          if (source && target && canvasEl) {
            var sourceRect = source.getBoundingClientRect();
            var targetRect = target.getBoundingClientRect();
            var canvasRect = canvasEl.getBoundingClientRect();
            pos = {
              x: mouseEvent.offsetX + 2 * sourceRect.left - (targetRect.left + canvasRect.left),
              y: mouseEvent.offsetY + 2 * sourceRect.top - (targetRect.top + canvasRect.top)
            };
          } else {
            pos = {
              x: (_b = mouseEvent.offsetX) !== null && _b !== void 0 ? _b : mouseEvent.clientX,
              y: (_c = mouseEvent.offsetY) !== null && _c !== void 0 ? _c : mouseEvent.clientY
            };
          }
        } else {
          if (mouseEvent.target === container.canvas.element) {
            pos = {
              x: (_d = mouseEvent.offsetX) !== null && _d !== void 0 ? _d : mouseEvent.clientX,
              y: (_e = mouseEvent.offsetY) !== null && _e !== void 0 ? _e : mouseEvent.clientY
            };
          }
        }
      } else {
        this.canPush = e.type !== "touchmove";
        var touchEvent = e;
        var lastTouch = touchEvent.touches[touchEvent.touches.length - 1];
        var _canvasRect = canvas === null || canvas === void 0 ? void 0 : canvas.getBoundingClientRect();
        pos = {
          x: lastTouch.clientX - ((_f = _canvasRect === null || _canvasRect === void 0 ? void 0 : _canvasRect.left) !== null && _f !== void 0 ? _f : 0),
          y: lastTouch.clientY - ((_g = _canvasRect === null || _canvasRect === void 0 ? void 0 : _canvasRect.top) !== null && _g !== void 0 ? _g : 0)
        };
      }
      var pxRatio = container.retina.pixelRatio;
      if (pos) {
        pos.x *= pxRatio;
        pos.y *= pxRatio;
      }
      container.interactivity.mouse.position = pos;
      container.interactivity.status = Constants.mouseMoveEvent;
    }
  }, {
    key: "mouseTouchFinish",
    value: function mouseTouchFinish() {
      var interactivity = this.container.interactivity;
      if (!interactivity) {
        return;
      }
      var mouse = interactivity.mouse;
      delete mouse.position;
      delete mouse.clickPosition;
      delete mouse.downPosition;
      interactivity.status = Constants.mouseLeaveEvent;
      mouse.inside = false;
      mouse.clicking = false;
    }
  }, {
    key: "mouseTouchClick",
    value: function mouseTouchClick(e) {
      var container = this.container,
        options = container.actualOptions,
        mouse = container.interactivity.mouse;
      mouse.inside = true;
      var handled = false;
      var mousePosition = mouse.position;
      if (!mousePosition || !options.interactivity.events.onClick.enable) {
        return;
      }
      var _iterator = _createForOfIteratorHelper(container.plugins),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
            plugin = _step$value[1];
          if (!plugin.clickPositionValid) {
            continue;
          }
          handled = plugin.clickPositionValid(mousePosition);
          if (handled) {
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (!handled) {
        this.doMouseTouchClick(e);
      }
      mouse.clicking = false;
    }
  }, {
    key: "doMouseTouchClick",
    value: function doMouseTouchClick(e) {
      var _this4 = this;
      var container = this.container,
        options = container.actualOptions;
      if (this.canPush) {
        var mousePos = container.interactivity.mouse.position;
        if (!mousePos) {
          return;
        }
        container.interactivity.mouse.clickPosition = {
          x: mousePos.x,
          y: mousePos.y
        };
        container.interactivity.mouse.clickTime = new Date().getTime();
        var onClick = options.interactivity.events.onClick;
        if (onClick.mode instanceof Array) {
          var _iterator2 = _createForOfIteratorHelper(onClick.mode),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var mode = _step2.value;
              this.handleClickMode(mode);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        } else {
          this.handleClickMode(onClick.mode);
        }
      }
      if (e.type === "touchend") {
        setTimeout(function () {
          return _this4.mouseTouchFinish();
        }, 500);
      }
    }
  }, {
    key: "handleThemeChange",
    value: function handleThemeChange(e) {
      var mediaEvent = e,
        themeName = mediaEvent.matches ? this.container.options.defaultDarkTheme : this.container.options.defaultLightTheme,
        theme = this.container.options.themes.find(function (theme) {
          return theme.name === themeName;
        });
      if (theme && theme.default.auto) {
        this.container.loadTheme(themeName);
      }
    }
  }, {
    key: "handleClickMode",
    value: function handleClickMode(mode) {
      this.container.handleClickMode(mode);
    }
  }]);
  return EventListeners;
}();